var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "相伴宝"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入你要搜索的关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.sortGoods()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "click": _vm.toShopCart,
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v("\n\t\t\t\t\t\t我的购物车\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none"
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品 ")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo, index) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('span', {
      attrs: {
        "name": "goodsName"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), (bo.specName != '') ? _c('span', [_vm._v("【" + _vm._s(bo.specName) + "】")]) : _vm._e()]), _vm._v("    "), _c('span', {
      staticStyle: {
        "color": "#f60"
      }
    }, [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.unitPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.id, bo.goodsCode, index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40218366","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = mtcC
// module chunks = 1